import { t } from '@lingui/core/macro'
import { createColumnHelper } from '@tanstack/react-table'
import React from 'react'
import { FaRegClone } from 'react-icons/fa6'
import { Produto, TipoAcesso, Usuario } from '@/core/types/graphql'
import { ProdutoPermissaoLabel } from './produto-permissao-label'

export type UsuarioPermissaoItem = Usuario & {
  tiposAcessoByProduto: {
    [key: string]: {
      produto: Produto
      tiposAcesso: TipoAcesso[]
    }
  }
}

const columnHelper = createColumnHelper<UsuarioPermissaoItem>()

interface ColumnsProps {
  setSelectedRow: (data: UsuarioPermissaoItem) => void
  handleOpenConfirmacao: () => void
  handleCloseClonar: () => void
}

export const columnsPermissao = ({
  setSelectedRow,
  handleOpenConfirmacao,
  handleCloseClonar
}: ColumnsProps) => {
  return [
    columnHelper.display({
      id: 'nome',
      header: t`Nome`,
      cell: ({ row: { original: usuario } }) => {
        return <p className={'font-bold'}>{usuario.nome}</p>
      }
    }),
    columnHelper.display({
      id: 'email',
      header: t`E-mail`,
      cell: ({ row: { original: usuario } }) => {
        return <p className={'font-bold'}>{usuario.email}</p>
      }
    }),
    columnHelper.display({
      id: 'tiposAcessoByProduto',
      header: t`Produtos e Permissões`,
      cell: ({ row: { original: usuario } }) => {
        return (
          <ProdutoPermissaoLabel
            tiposAcessoByProduto={usuario.tiposAcessoByProduto}
          />
        )
      }
    }),
    columnHelper.display({
      id: 'clone',
      header: '',
      cell: ({ row: { original: usuario } }) => {
        return (
          <div
            className={'hover:cursor-pointer hover:text-primary-medium'}
            onClick={() => {
              setSelectedRow(usuario)
              handleOpenConfirmacao()
              handleCloseClonar()
            }}
          >
            <FaRegClone />
          </div>
        )
      }
    })
  ]
}
